import { render, staticRenderFns } from "./PolicyProductShort.vue?vue&type=template&id=14f24dfe&scoped=true"
import script from "./PolicyProductShort.vue?vue&type=script&lang=ts"
export * from "./PolicyProductShort.vue?vue&type=script&lang=ts"
import style0 from "./PolicyProductShort.vue?vue&type=style&index=0&id=14f24dfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f24dfe",
  null
  
)

export default component.exports